import { CONFIG } from '@h2h/shared';

export const URGENT_MS = 60 * 60 * 1000;
export const TOTAL = CONFIG.CYCLING.DUELS_PER_STAGE;
